// extracted by mini-css-extract-plugin
export default {"popper":"styles_popper__RRfvJ"};